import { CheckIcon } from '@wolfejs/icons/IconMap';
import { useAdminBuyerUpdate } from '@wolfejs/ms-api-react/src/hooks/admin/buyers';
import { Button } from '@wolfejs/ui/Button';
import { Tooltip } from '@wolfejs/ui/Tooltip';
import { UIColorContext, UIColorStates, UIShapes, UISizes, UIVariants } from '@wolfejs/ui/types/UI';

export const toggleIsApprovedForBuying = (value: boolean, id: string) => {
  const updateBuyer = useAdminBuyerUpdate();

  const onApproveForBuying = async () => {
    const updateData = {
      id,
      business: {
        isApprovedForBuying: !value,
      },
    };
    const updateRes = await updateBuyer.mutateAsync(updateData);
  };

  return (
    <Tooltip text={value ? 'Revoke approval' : 'Approve for Buying'}>
      <span className="mr-2">{value.toString()}</span>
      <Button
        onClick={() => onApproveForBuying()}
        size={UISizes.xs}
        variant={UIVariants.outline}
        shape={UIShapes.rounded}
        color={value ? UIColorStates.warning : UIColorContext.primary}
        className="h-[22px]"
      >
        <CheckIcon /> <span className="ml-1">{value ? 'Revoke approval' : 'Approve For Buying'}</span>
      </Button>
    </Tooltip>
  );
};
